import { Page } from 'layouts/Page';
import { FC } from 'react';
import { ConfirmedOrders } from 'components/ConfirmedOrders';

export const OrdersPage: FC = () => {
	return (
		<Page title="Orders – EAS Dashboard">
			<ConfirmedOrders />
		</Page>
	);
};
